import React, { useState, useEffect, useRef } from "react";
import { getIn } from "formik";
import { findUnitKeyByCoincidence } from "../../services/CatalogService";

const CustomAutoCompleteUnitKey = ({ 
  widthClass = "col-md-4",
  hideLabel = false,
  labelAlign = "center",
  ...props }) => {
    
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const timeoutIdRef = useRef(null);

  const error =
    getIn(props.formik.touched, props.field) &&
    getIn(props.formik.errors, props.field);

  const handleChange = (event) => {
    const inputValue = event.target.value;
    setText(inputValue);

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    if (inputValue.trim() === "") {
      setOptions([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    timeoutIdRef.current = setTimeout(async () => {
      try {
        const data = await findUnitKeyByCoincidence(inputValue);
        setOptions(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }, 500);
  };

  const handleSelect = (data) => {
    setValue(data);
    setText(`(${data?.idKey}) ${data?.description}`);
    setShowOptions(false);
    props.formik.setFieldValue(props.field, data);
  };

  const clearSelection = () => {
    setText("");
    setValue("");
    setOptions([]);
    setShowOptions(false);
    props.formik.setFieldValue(props.field, null);
  };

  useEffect(() => {
    if (text.trim() !== "") {
      handleChange({ target: { value: text } });
    }
  }, [text]);

  useEffect(() => {
    const initial = props.formik.values[props.field];
    if (initial && initial.idKey) {
      setValue(initial);
      setText(`(${initial.idKey}) ${initial.description}`);
    }
  }, [props.formik.values, props.field]);
  
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className={widthClass}>
        <div className="form-group">
          {!hideLabel && (
            <label
              className="form-label"
              style={{
                color: error ? "red" : "inherit",
                display: "block",
                textAlign: labelAlign,
              }}
            >
              Clave de unidad&nbsp;
              <span style={{ color: error ? "red" : "inherit" }}>*</span>
            </label>
          )}

          <div style={{ position: "relative" }}>
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  zIndex: 2,
                }}
              >
                <span
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                />
              </div>
            )}

            {text && (
              <button
                type="button"
                onClick={clearSelection}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  color: "#999",
                  cursor: "pointer",
                  zIndex: 2,
                  padding: 0,
                  lineHeight: 1,
                }}
              >
                <i className="fa fa-times" />
              </button>
            )}

            <input
              type="text"
              className={`form-control ${error ? "is-invalid" : ""}`}
              placeholder="Clave de unidad"
              id="unit-key-input"
              value={text}
              style={{
                paddingLeft: loading ? "2rem" : undefined,
                paddingRight: "2rem",
              }}
              onChange={handleChange}
              onFocus={() => setShowOptions(true)}
              onBlur={() => setShowOptions(false)}
              autoComplete="password"
            />

            {options.length > 0 && showOptions && (
              <ul
                className="list-group mt-2"
                style={{
                  position: "absolute",
                  zIndex: 1000,
                  backgroundColor: "white",
                  width: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  top: "calc(100% + -8px)",
                }}
              >
                {options.map((data, index) => (
                  <li
                    key={index}
                    className="list-group-item list-group-item-action"
                    onMouseDown={() => handleSelect(data)}
                  >
                    ({data?.idKey}) {data?.description}
                  </li>
                ))}
              </ul>
            )}

            {options.length === 0 && showOptions && !loading && (
              <ul
                className="list-group"
                style={{
                  position: "absolute",
                  zIndex: 1000,
                  backgroundColor: "white",
                  width: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  top: "100%",
                  marginTop: "0.25rem",
                }}
              >
                <li className="list-group-item list-group-item-action">
                  No hay resultados
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomAutoCompleteUnitKey;